// Store the intended destination in sessionStorage
export const storeRedirectPath = (path) => {
  if (path && path !== '/login' && path !== '/sign_up') {
    sessionStorage.setItem('redirectAfterLogin', path);
  }
};

// Get the stored redirect path and clear it
export const getAndClearRedirectPath = () => {
  const redirectPath = sessionStorage.getItem('redirectAfterLogin');
  if (redirectPath) {
    sessionStorage.removeItem('redirectAfterLogin');
    return redirectPath;
  }
  return null;
};

// Check if there's a stored redirect path
export const hasStoredRedirect = () => {
  return sessionStorage.getItem('redirectAfterLogin') !== null;
}; 